import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SeoFooter } from "@/components/SeoFooter";
import { StickyQuote } from "@/components/StickyQuote";
import { CustomCursor } from "@/components/CustomCursor";

export function Layout() {
  const { pathname } = useLocation();
  const isProjectLanding = pathname.startsWith('/start/');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <CustomCursor />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      {!isProjectLanding && <SeoFooter />}
      <Footer />
      {!isProjectLanding && <StickyQuote />}
    </div>
  );
}
